import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'relative z-0',
    button: 'flex items-center justify-center',
    icon: 'rotate-90 transition-transform duration-150'
  },
  variants: {
    open: {
      true: {
        icon: '-scale-100'
      }
    }
  }
});
